var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      class: {
        "section-div":
          _vm.credential && _vm.credential.apiEncryptedUser && _vm.theme === 1,
        "section-div-separator":
          _vm.credential &&
          _vm.credential.apiEncryptedUser &&
          _vm.section != "JEWELLERY"
      }
    },
    [
      _vm.visibleCategories && _vm.visibleCategories.length > 0
        ? _c("div", [
            _vm.section == "JEWELLERY" &&
            _vm.credential &&
            _vm.credential.apiEncryptedUser
              ? _c("div", { staticClass: "row warranty-registration" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-secondary warranty-btn",
                          attrs: { href: _vm.warrantyUrl, target: "_blank" }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("registerWarranty")) + " "
                          ),
                          _c("font-awesome-icon", {
                            staticClass: "info-button cursor-pointer",
                            attrs: {
                              id: "popover-target-1",
                              icon: ["fas", "info-circle"]
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "b-popover",
                        {
                          attrs: {
                            target: "popover-target-1",
                            triggers: "hover",
                            placement: "top"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function() {
                                  return [_vm._v("Garanzie")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1185357008
                          )
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("registerWarrantyTooltip")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "section-title-div",
                class: ["section-title-div-" + _vm.theme]
              },
              [
                _vm.theme === 1
                  ? _c("div", { staticClass: "section-title-line-div" }, [
                      _c("span", { staticClass: "section-title-line" })
                    ])
                  : _vm._e(),
                _c("span", { class: ["section-title-" + _vm.theme] }, [
                  _vm._v(" " + _vm._s(_vm.$t(_vm.section.toLowerCase())) + " ")
                ]),
                _vm.theme === 1
                  ? _c("div", { staticClass: "section-title-line-div" }, [
                      _c("span", { staticClass: "section-title-line" })
                    ])
                  : _vm._e()
              ]
            ),
            _vm.section == "ACCESSORIES"
              ? _c(
                  "div",
                  { staticClass: "color-configure-descr-accessories" },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("accessoriesInit")))])]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "row justify-content-center" },
              _vm._l(_vm.visibleCategories, function(category) {
                return _c(
                  "div",
                  {
                    key: category.id,
                    staticClass: "col-6 col-md-4 col-lg-3 mb-3"
                  },
                  [
                    category.id !== 999 ||
                    //aggiungere anche per pronta consegna
                    (category.id === 999 &&
                      _vm.credential &&
                      _vm.credential.apiEncryptedUser)
                      ? _c(
                          "div",
                          {
                            staticClass: "cursor-pointer",
                            class: [
                              _vm.section + "-top-border-category",
                              "top-border-category-" + _vm.theme
                            ],
                            on: {
                              click: function($event) {
                                return _vm.selectCat(category)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "border-category",
                              class: {
                                "pendant-category":
                                  _vm.theme == 2 &&
                                  (category.id == 2 || category.id == 3)
                              },
                              attrs: { src: _vm.getImage(category) }
                            }),
                            _vm.theme === 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "col text-center cat-jewel",
                                    class: _vm.section + "-cat-jewel"
                                  },
                                  [
                                    _c("div", { staticClass: "cat-name" }, [
                                      _vm._v(_vm._s(category.name))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm.theme === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "col text-center cat-jewel-1",
                            class: _vm.section + "-cat-jewel"
                          },
                          [
                            _c("div", { staticClass: "cat-name" }, [
                              _vm._v(_vm._s(category.name))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }